<div class="small-popup-info-modal-overlay">
    <div class="small-popup-info-modal">
        <MdIconClose data-qa-id="small-popup-info-modal-close-icon" class="closeIcon" @click="closeModal" />
        <div class="small-popup-info-modal-content">
            <div>
                <MdTypography data-qa-id="small-popup-info-modal-heading" tag="h6" variant="body1--medium" responsive="false">
                    {{ heading }}
                </MdTypography>
            </div>
            <div>
                <MdTypography data-qa-id="small-popup-info-modal-body-text" tag="span" variant="body2--regular" color="spirits--800" responsive="false">
                    {{ body }}
                </MdTypography>
            </div>
        </div>

        <MdButton :disabled="!agreementButtonDisabled" data-qa-id="small-popup-info-modal-button" color="yellow" fullwidth="true" @click="handleButtonClick">
            <MdIconAgreements v-if="!agreementButtonDisabled" data-qa-id="small-popup-info-modal-icon"
                iconTitle="disabled" size="sm" />
            <MdIconLock v-else data-qa-id="small-popup-info-modal-lock-icon" iconTitle="disabled" size="sm"/>    
            &nbsp;
            <span>
                {{ btnText }}
            </span>
        </MdButton>
    </div>
</div>